import type { ConstValues } from '@openx/types/helpers.ts';

export const ColumnKey = {
  NAME: 'name',
  DEVICE_TYPE: 'device_type',
  DISTRIBUTION_CHANNEL: 'distribution_channel',
  AD_PLACEMENT: 'ad_placement',
} as const;
export type ColumnKey = ConstValues<typeof ColumnKey>;

export const ColumnTitle = {
  NAME: 'Name',
  DEVICE_TYPE: 'Device',
  DISTRIBUTION_CHANNEL: 'Channel',
  AD_PLACEMENT: 'Format',
} as const;
export type ColumnTitle = ConstValues<typeof ColumnTitle>;
